import ApiService from '@/services/api.service'

const PhysiciansOrdersOptionsService = {

    getAll() {          
        const requestData = {
            method: 'get',
            url: "/PhysiciansOrdersOptions",
            headers: {
                
              },
            params: { 
               
            }
        }
        return ApiService.customRequest(requestData);
    },    

    getPhysiciansOrdersOptions(){
        return ApiService.get(`/PhysiciansOrdersOptions`);
    },
    
}
  
  export default PhysiciansOrdersOptionsService;